import { RefetchQueriesOptions, useApolloClient } from '@apollo/client';

const fieldNames = [
  'profile',
  'workspace',
  'workspaceMembers',
  'workspaceVariables',
  'wizard',
  'organisation',
  'organisationMembers',
  'flatOrganisationsHome',
  'flatOrganisationsUser',
  'flatOrganisationsNav',
  'user',
  'assessments',
  'assessmentsScenarioNames',
  'assessmentsList',
  'assessment',
  'assessmentVariables',
  'assessmentRiskRegister',
  'incidents',
  'incidentsCheck',
  'incident',
  'incidentLinkedScenarios',
  'controls',
  'controlsRmpCheck',
  'controlsRmp',
  'assessmentScenariosWizard',
  'control',
  'controlLinkedScenarios',
  'scenario',
  'scenarioRmp',
  'scenarioControls',
  'events',
  'event',
  'controlFrameworkDetails',
  'complianceFramework',
  'filtersFor',
  'controlRmp',
  'controlModifier',
  'scenarioModifier',
  'scenarioIncidents',
] as const;

export type KeyType = (typeof fieldNames)[number];

type RefetchQuery = (params?: {
  include?: KeyType[] | 'all';
  options?: RefetchQueriesOptions<any, any>;
}) => Promise<any>;

export const useCache = () => {
  const client = useApolloClient();

  const refetchQuery: RefetchQuery = async (params) => {
    const { include, options } = params || {};

    await client.refetchQueries({
      include,
      optimistic: false,
      ...options,
    });
  };

  return { refetchQuery };
};
